export function usePagination({ itemsName = 'paginationItems' } = {}) {
  return {
    data() {
      return {
        pageNum: this.$route.query.pageNum || '1',
        goBack: {
          text: 'Back to previous',
          callback: () => this.$router.go(-1),
        },
      };
    },
    computed: {
      noContent() {
        return this[itemsName].length < 1;
      },
      pagedItemsCount() {
        return this[itemsName].length;
      },
    },
    watch: {
      pageNum(newValue) {
        if (Number(newValue) !== Number(this.$route.query.pageNum)) {
          this.$router.push({
            query: {
              ...this.$route.query,
              pageNum: newValue,
            },
          });
        }
      },
      // eslint-disable-next-line
      '$route.query.pageNum'(newValue) {
        if (Number(newValue) !== Number(this.pageNum)) {
          this.pageNum = newValue;
        }
      },
    },
  };
}

export default {};
